import '../../common/bn-icon';
import './farm-address';
import './organization-ancestors-bread-crumbs';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class FarmHeader extends LitEntity {
  static get properties() {
    return {
      includeMapLinks: { type: Boolean, attribute: 'include-map-links' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
      }
      .headings {
        flex-grow: 1;
      }
      bn-icon {
        color: var(--blue-60);
        font-size: 40px;
        margin-right: 1rem;
      }
      h3 {
        margin-top: 0;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html``;
    }

    return html`
      <bn-icon name="fad fa-farm"></bn-icon>
      <div class="headings">
        <h3>
          <organization-ancestors-bread-crumbs
            .href="${this.href}"
            ancestorMinIndex="0"
            stop-at-type="binsentry"
          ></organization-ancestors-bread-crumbs>
        </h3>
        <h4>
          <farm-address .href="${this.href}" ?include-map-links="${this.includeMapLinks}"></farm-address>
        </h4>
      </div>
    `;
  }
}

customElements.define('farm-header', FarmHeader);
